module.exports = __webpack_public_path__ + "static/media/AUS.6a0c4107.svg";